(function(){
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  function getCart(){ return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function addVariant(id, btn){
    var cart = getCart();
    var body = new FormData();
    body.append('id', id); body.append('quantity', 1);
    if(cart && typeof cart.getSectionsToRender === 'function'){
      try { var ids = cart.getSectionsToRender().map(function(s){ return s.id; }); body.append('sections', ids); body.append('sections_url', window.location.pathname); } catch(e){}
    }
    var label = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Añadiendo...'; }
    fetch(root + 'cart/add.js', {method:'POST', headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'}, body: body})
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(res && res.status){ if(btn){ btn.disabled=false; btn.textContent = label || 'Añadir'; } return; }
        if(cart && typeof cart.renderContents === 'function'){ cart.renderContents(res); }
        if(typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate){ try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {source:'mpro-cart', cartData: res}); } catch(e){} }
        if(btn){ btn.textContent = '✓ Añadido'; btn.classList.add('is-done'); }
      })
      .catch(function(){ if(btn){ btn.disabled=false; btn.textContent = label || 'Añadir'; } });
  }
  function swapToPack(packId, removeIds, btn){
    if(!packId){ return; }
    var updates = {};
    (removeIds || '').split(',').forEach(function(v){ v = (v || '').trim(); if(v){ updates[v] = 0; } });
    if(btn){ btn.disabled = true; btn.textContent = 'Cambiando...'; }
    if(!Object.keys(updates).length){ addVariant(packId, btn); return; }
    fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body: JSON.stringify({updates: updates})})
      .then(function(r){ return r.json(); })
      .then(function(){ addVariant(packId, btn); })
      .catch(function(){ if(btn){ btn.disabled=false; btn.textContent = 'Cambiar al pack'; } });
  }
  function refreshDrawer(){
    var live = document.querySelector('#CartDrawer'); if(!live) return;
    fetch(root + '?sections=cart-drawer', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(j){ var html = j && j['cart-drawer']; if(!html) return; var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer'); if(fresh){ live.innerHTML = fresh.innerHTML; } })
      .catch(function(){});
  }
  function observeDrawer(){ var d = getCart(); if(!d) return;
    function sync(){ var open = d.classList.contains('active'); document.documentElement.classList.toggle('mpro-drawer-open', open); if(open && !d.classList.contains('is-empty') && !d.querySelector('.mpro-ce')){ refreshDrawer(); } }
    if(window.MutationObserver){ var mo = new MutationObserver(function(muts){ for(var i=0;i<muts.length;i++){ if(muts[i].attributeName === 'class'){ sync(); break; } } }); mo.observe(d, {attributes:true, attributeFilter:['class']}); }
    sync();
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    var sw = t.closest ? t.closest('.mpro-swap') : null;
    if(sw){ e.preventDefault(); if(sw.disabled) return; swapToPack(sw.getAttribute('data-id'), sw.getAttribute('data-swap'), sw); return; }
    var up = t.closest ? t.closest('.mpro-up__add') : null;
    if(up){ e.preventDefault(); if(up.disabled) return; var id = up.getAttribute('data-id'); if(id){ addVariant(id, up); } return; }
    var sk = t.closest ? t.closest('.mpro-sticky__btn') : null;
    if(sk){
      e.preventDefault();
      if(sk.hasAttribute('disabled')) return;
      // La barra fija delega en el boton real del formulario: asi hereda SIEMPRE
      // la cantidad elegida, el plan de suscripcion, la variante y las validaciones.
      var realBtn = document.querySelector('product-form .product-form__submit') || document.querySelector('.product-form__submit');
      if(realBtn && !realBtn.disabled){
        var lbl = sk.textContent;
        sk.disabled = true; sk.textContent = 'Añadiendo...';
        realBtn.click();
        setTimeout(function(){
          sk.disabled = false;
          sk.textContent = '✓ Añadido';
          sk.classList.add('is-done');
          setTimeout(function(){ sk.textContent = lbl; sk.classList.remove('is-done'); }, 1800);
        }, 1300);
        return;
      }
      // Reserva: si no hay formulario en la pagina, anadimos la variante directamente.
      var sid = sk.getAttribute('data-id');
      var form = document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if(form){ var inp = form.querySelector('[name="id"]'); if(inp && inp.value){ sid = inp.value; } }
      if(sid){ addVariant(sid, sk); }
      return;
    }
  });
  function initSticky(){ var bar = document.querySelector('.mpro-sticky'); if(!bar) return; var anchor = document.querySelector('.product-form__buttons') || document.querySelector('product-form') || document.querySelector('.product-form__submit'); var wa = document.querySelector('.mpro-wa');
    function setVisible(v){ bar.classList.toggle('is-visible', v); if(wa){ wa.classList.toggle('mpro-wa--up', v); } }
    if(anchor && 'IntersectionObserver' in window){ var io = new IntersectionObserver(function(entries){ for(var i=0;i<entries.length;i++){ setVisible(!entries[i].isIntersecting); } }, {rootMargin:'0px 0px -8px 0px'}); io.observe(anchor); } else { setVisible(true); }
  }
  function init(){ initSticky(); observeDrawer(); }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();